import Vue from "vue";

import comboComponent from "@/components/child/form/combo.vue";
import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component, Prop, Watch } from "@/decorators";
import TipoTemplateWhatsApp from "@/models/enum/TiposTemplateWhatsApp";
import ModeloImpressaoCampos from "@/models/modeloImpressao/modeloImpressaoCamposModel";
import ModeloImpressao from "@/models/modeloImpressao/modeloImpressaoModel";
import ModeloImpressaoSessaoModel from "@/models/modeloImpressao/modeloImpressaoSessaoModel";
import ManipulacaoOrdemService from "@/services/manipulacaoOrdemService";
import VendaService from "@/services/vendaService";

@Component({
    components: {
        comboComponent,
        shortcutComponent,
    },
})
export default class TagsComponent extends Vue {
    @Prop({ type: Number, required: true }) tipo: number;

    private shortcutComponent: ShortcutComponent = null;
    private dados = 0;
    private campos = 0;
    private classFullName: string = null;
    telaName: string = null;

    dadosOptions: Array<Object> = [];
    camposOptions: Array<Object> = [];
    private model = new ModeloImpressao();
    sessao = new ModeloImpressaoSessaoModel();

    public async show() {
        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;
        this.loadClassName();
        this.shortcutComponent.title = this.$t("__.ts.addTags") as string;
        this.shortcutComponent.show();
    }

    private async getCamposComDisplayName() {
        let campos = new Array<ModeloImpressaoCampos>();
        if (this.classFullName) {
            campos = await this.model.GetCamposComDisplayName(this.classFullName);
        }

        const sessao = new ModeloImpressaoSessaoModel();
        sessao.campos = campos;
        this.loadSessao(sessao);
        return campos;
    }

    private async loadClassName() {
        switch (this.tipo) {
            case TipoTemplateWhatsApp.EnvioOrcamentoContinuos:
            case TipoTemplateWhatsApp.CompartilharOrcamento:
                this.classFullName = await new VendaService().getFullClassName().resolveWithText();
                break;
            default:
                this.classFullName = await new ManipulacaoOrdemService().getFullClassName().resolveWithText();
        }

        this.getCamposComDisplayName();
    }

    public async loadSessao(sessao: ModeloImpressaoSessaoModel) {
        this.sessao = new ModeloImpressaoSessaoModel();
        this.sessao.campos.splice(0);

        this.sessao.updateFrom(sessao);
        this.dadosOptions.splice(0);

        const dadosDesordenados = this.sessao.campos
            .filter(p => !(p.labelName?.includes("Dados da Franquia") && p.codGroup?.includes(".")))
            .filter(p => p.header)
            .filter(p => this.sessao.campos.some(c => !c.header && c.parentIndex == p.index))
            .map(item => ({
                value: item.index,
                text: item.codGroup + " - " + item.labelName,
            }));

        this.dadosOptions = dadosDesordenados.sort((n1, n2) => n1["value"] - n2["value"]);

        this.dados = 0;
        if (this.tipo == TipoTemplateWhatsApp.CompartilharOrcamento) {
            const dadoItemComValor = { value: 999997, customizado: "ItensVendaComValor", text: "Itens Venda com Valor" };
            this.dadosOptions.unshift(dadoItemComValor);
            const dadoItem = { value: 999999, customizado: "ItensVenda", text: "Itens Venda" };
            this.dadosOptions.unshift(dadoItem);
        }

        if (this.tipo > 1 && this.tipo < 8) {
            const dadosVenda = { value: 999998, customizado: "Dados Venda", text: "Dados Venda" };
            this.dadosOptions.unshift(dadosVenda);
        }

        const mainDado = { value: 0, text: this.tipo == 1 || this.tipo == 8 ? "Dados Venda" : "Dados Manipulação" };
        this.dadosOptions.unshift(mainDado);
        this.camposOptions = this.sessao.campos
            .filter(p => !p.header && p.parentIndex == this.dados)
            .map(item => ({
                value: item.index,
                text: item.codGroup + " - " + item.labelName,
                label: item.labelId,
            }));
    }

    @Watch("dados")
    private onDadosChanged() {
        if (this.dados == 999998) {
            this.camposOptions = [{ value: this.dados, text: "Codigo Rastreio", label: "CodigoRastreio" }];
        } else {
            this.camposOptions = this.sessao.campos
                .filter(
                    p =>
                        !p.header &&
                        p.parentIndex == this.dados &&
                        document.getElementById((p.index * -1).toString()) == null,
                )
                .map(item => ({
                    value: item.index,
                    text: item.codGroup + " - " + item.labelName,
                    label: item.labelId,
                }));
        }
    }

    private onConfirm() {
        const valor = this.camposOptions.find(item => item["value"] == this.campos);
        if (valor) {
            this.$emit("campo", valor["label"]);
            return this.shortcutComponent.hide();
        }

        const dado = this.dadosOptions.find(item => item["value"] == this.dados);
        if (dado && dado["customizado"]) {
            this.$emit("campo", dado["customizado"]);
            return this.shortcutComponent.hide();
        }
    }
}
